export default __webpack_public_path__ + "static/media/pc.4cd0987e.png";